module.exports = __webpack_public_path__ + "static/media/aboutus-img.d7b55165.jpg";